$(function(){
    if (typeof imgsUrls !== 'undefined') {
        imgsUrls.forEach(imgUrl => {
            const img = document.createElement('img')
            img.src = imgUrl
        })
    }
})